import React from 'react';
import './MediaGallery.scss';
import { Avatar, IconChevronLeft, IconChevronRight, Dialog } from 'cdk-radial';
import BackIcon from '../common/images/media_left_arrow.svg';
import ForwardIcon from '../common/images/media_right_arrow.svg';
import { injectIntl } from 'react-intl';

const YOUTUBE = 'youtube.com',
  YOUTUBE_OTHER = /^\/(shorts|live)\/(.+)$/i,
  YT_BE = 'youtu.be',
  VIMEO = 'vimeo.com',
  BACK_ARW_ENB = 'videoCell__back-arrow',
  FORW_ARW_ENB = 'videoCell__next-arrow';

function getVideoId(videoUrl) {
  // this doesn't validate all aspects of the url. that already happened on submission
  if (!videoUrl) return;
  // invalid urls are trapped further up
  const url = new URL(videoUrl);

  if (url.hostname.includes(YOUTUBE)) {
    if (url.pathname === '/watch') {
      const videoId = url.searchParams.get('v');
      if (!videoId) return;
      return {
        platform: 'youtube',
        id: videoId
      };
    } else if (YOUTUBE_OTHER.test(url.pathname)) {
      const match = url.pathname.match(YOUTUBE_OTHER);
      return {
        platform: 'youtube',
        id: match[2]
      };
    }
  } else if (url.hostname === YT_BE) {
    return {
      platform: 'youtube',
      id: url.pathname.substring(1)
    };
  } else if (url.hostname.includes(VIMEO)) {
    return {
      platform: 'vimeo',
      id: url.pathname.substring(1)
    };
  }
}

function getVideoEmbedUrl(videoUrl) {
  const vid = getVideoId(videoUrl);
  if (!vid) return;

  switch (vid.platform) {
    case 'youtube':
      return `https://www.youtube.com/embed/${vid.id}?autoplay=1&rel=0`;
    case 'vimeo':
      return `https://player.vimeo.com/video/${
        vid.id
      }?title=0&byline=0&portrait=0&transparent=0&autoplay=1`;
    default:
  }
}

class GalleryVideos extends React.Component {
  state = {
    dialogOpen: false,
    embedUrl: '',
    title: '',
    page: 0,
    videos: [],
    showNavigation: true,
    showLeftNavArrow: false,
    showRighNavArrow: true,
    maxScrollLeftValue: -1
  };

  componentDidMount() {
    let {
      props: { videos }
    } = this;
    this.setState({ videos });
  }

  componentDidUpdate(prevProps, prevState) {
    this.updateScrollWidthAndClientWidth(
      prevState.scrollWidth,
      prevState.clientWidth
    );
  }

  isValidUrl = string => {
    const URLRegex = /^(http|https):\/\/(www\.)?(?!\.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,5}(:[-a-zA-Z0-9]{1,10})?(\/.*)?$/i;
    let regex = URLRegex;
    return regex.test(string);
  };

  updateScrollWidthAndClientWidth = (scrollWidth, clientWidth) => {
    let elmnt = document.getElementById('video-gallery-frame');
    if (!elmnt) {
      return null;
    }
    if (
      elmnt.scrollWidth !== scrollWidth ||
      elmnt.clientWidth !== clientWidth
    ) {
      this.setState({
        scrollWidth: elmnt.scrollWidth,
        clientWidth: elmnt.clientWidth
      });
      this.showNavigationHandler();
    }
  };

  showNavigationHandler = () => {
    let maxScrollLeftValue = this.state.scrollWidth - this.state.clientWidth;
    if (maxScrollLeftValue <= 0) {
      this.setState({ showNavigation: false });
    } else {
      this.setState({ maxScrollLeftValue: maxScrollLeftValue });
    }
  };

  rightArrowClickHandler = () => {
    let elmnt = document.getElementById('video-gallery-frame');
    elmnt.scrollLeft = elmnt.scrollLeft + elmnt.clientWidth;
  };

  leftArrowClickHandler = () => {
    let elmnt = document.getElementById('video-gallery-frame');
    elmnt.scrollLeft = elmnt.scrollLeft - elmnt.clientWidth;
  };

  onscroll = () => {
    let elmnt = document.getElementById('video-gallery-frame');
    if (elmnt.scrollLeft === 0) {
      this.setState({ showLeftNavArrow: false });
    } else {
      this.setState({ showLeftNavArrow: true });
    }

    if (
      Math.floor(elmnt.scrollLeft) >= Math.floor(this.state.maxScrollLeftValue)
    ) {
      this.setState({ showRighNavArrow: false });
    } else {
      this.setState({ showRighNavArrow: true });
    }
  };

  onClose = () => {
    this.setState({ dialogOpen: false, embedUrl: '', title: '' });
  };

  showPopUp = (url, title) => {
    const embedUrl = getVideoEmbedUrl(url);

    if (embedUrl) {
      this.setState({
        embedUrl,
        title,
        dialogOpen: true
      });
    }
  };

  getDefaultImgComponent = url => {
    const videoId = getVideoId(url);
    if (!videoId) return null;

    switch (videoId.platform) {
      case 'youtube':
        return (
          <img
            className="video_img"
            alt={videoId.id}
            src={`https://img.youtube.com/vi/${videoId.id}/hqdefault.jpg`}
          />
        );
      case 'vimeo':
        return (
          <iframe
            className="video_img"
            title={videoId.id}
            src={`https://player.vimeo.com/video/${
              videoId.id
            }?title=0&byline=0&portrait=0&transparent=0&autoplay=0&background=1`}
            frameBorder="0"
          />
        );
      default:
    }
  };

  render() {
    const {
      props: { isPreview },
      state: { videos, showNavigation, showLeftNavArrow, showRighNavArrow }
    } = this;
    return (
      <div className="videoCell__div" onScroll={this.onscroll}>
        {showNavigation && showLeftNavArrow && (
          <Avatar
            className={BACK_ARW_ENB}
            color="700"
            data-testid="left-avatar"
            icon={<IconChevronLeft />}
            size="small"
            src={BackIcon}
            variant="icon"
            onClick={this.leftArrowClickHandler}
          />
        )}
        <div id="video-gallery-frame" className="video-gallery-frame">
          <div className="video-gallery-images-container ">
            {videos.map(({ url, title, description }, key) => {
              return (
                url &&
                this.isValidUrl(url) && (
                  <div key={key} className="videoCell__mask">
                    <div className="videoCell__video-list">
                      <div className="play_button_wrapper">
                        <div
                          data-cy={`div_galleryvideos_playbutton_${key}`}
                          className="play_button"
                          role="button"
                          aria-label="Play video"
                          onClick={() => this.showPopUp(url, title)}
                        >
                          <svg viewBox="0 0 200 200" alt="Play video">
                            <circle
                              cx="100"
                              cy="100"
                              r="90"
                              fill="rgba(144, 144, 144, 0.72)"
                              strokeWidth=""
                              stroke=""
                            />
                            <polygon
                              points="70, 55 70, 145 145, 100"
                              fill="rgba(255, 255, 255, 0.6)"
                            />
                          </svg>
                        </div>
                        <div className="video_wrapper">
                          {this.getDefaultImgComponent(url)}
                        </div>
                      </div>
                    </div>
                    <div className="videoCell__title">{title}</div>
                    <div className="videoCell__description">{description}</div>
                  </div>
                )
              );
            })}
          </div>
        </div>
        {showNavigation && showRighNavArrow && (
          <Avatar
            className={FORW_ARW_ENB}
            color="700"
            data-testid="right-avatar"
            icon={<IconChevronRight />}
            size="small"
            src={ForwardIcon}
            variant="icon"
            onClick={this.rightArrowClickHandler}
          />
        )}

        <div className="mdc_dilog_parent">
          {this.state.dialogOpen && !isPreview && (
            <Dialog
              isOpen={this.state.dialogOpen}
              disableOverlayClicked={true}
              className="videoCell_dilog_body"
              onClose={this.onClose}
              title={this.state.title}
            >
              <iframe
                data-testid="videoCell-frame"
                style={{
                  height: '500px',
                  width: '100%'
                }}
                title={this.state.embedUrl}
                src={this.state.embedUrl}
                frameBorder="0"
              />
            </Dialog>
          )}
        </div>
      </div>
    );
  }
}

export default injectIntl(GalleryVideos);
